// extracted by mini-css-extract-plugin
export default {"melodyVideo":"FM-z","isFullWidth":"GM-z","landingPageVideo":"HM-z","play":"IM-z","iframeVideo":"JM-z","playHidden":"KM-z","fullwidth":"LM-z"};